import get from 'lodash/get';

export default function normalizeDataSetData(dataSet) {
  const dataSetData = get(dataSet, 'data');

  if (!dataSetData || typeof dataSetData !== 'object' || Array.isArray(dataSetData)) {
    return {};
  }

  return dataSetData;
}
